module.exports = __webpack_public_path__ + "static/img/female-bg-pt.8e3903b8.png";